<!--
 * @Author: hfxie
 * @Date: 2021-01-01 14:52:54
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-08-09 17:28:28
 * @Description: 甘特图右侧下方网格线表单文案内容组件·统计区

-->
<!-- 甘特图背景网格 -->
<template>
  <div
    class="content-form"
    @scroll.passive="scrollEvent($event)"
  >
    <!-- 行 -->
    <div
      v-if="!isHide && rowsShow.length > 0"
      class="cols"
      :style="getHeight"
    >
      <template v-for="(row, indRow) in rowsShow">
        <div
          class="gantt-row"
          :key="row.id"
          :style="{
            'height': (row.rowCount * estimatedItemSize  + 'px'),
          }"
        >
          <!-- 列 -->
            <template v-for="(item2, index2) in timesArr">
              <div
                class="cell-col"
                :key="index2 + $store.state.cellUnitType"
                :style="{
                  'width': $store.getters.cellWidth + 'px',
                  'left': index2 * $store.getters.cellWidth + 'px',
                }"
              >
                {{ index2 > 1?(showArr[indRow]? showArr[indRow][index2 - 2]: "-"): "-" }}
              </div>
            </template>

        </div>
      </template>
    </div>
    <div v-else class="empty-box">
      <div v-for="(row, index) in summaryBody.data" :key="index" class="row">
        <div
          :style="{
            width: $store.getters.cellWidth * 2 + 'px',
          }"
          class="summary-data no-border-left no-flex-shrink"
        ></div>
        <div
          v-for="(item, j) in row"
          class="summary-data"
          :key="j"
          :class="{
            'isNegative': item < 0,
          }"
          :style="{
            width: ((typeof summaryBody.rate[j] == 'number')? summaryBody.rate[j]: 1) * $store.getters.cellWidth + 'px',
          }"
          :title="item"
        >
          {{ item }}
        </div>
      </div>

    </div>

  </div>
</template>
<script>
export default {
  name: "ContentForm",
  props: {
    isHide: {
      type: Boolean,
      default: () => { return false; },
    },
    rowsShow: {
      type: Array,
      default: () => { return []; },
    },
    timesArr: {
      type: Array,
      default: () => { return []; },
    },
    cols: {
      type: Array,
      default: () => { return []; },
    },
    ganttType: {
      type: String,
      default: "pageData",
    },
    // 滚动联动对象
    reactVueComponent: {
      type: Object,
      default: null,
    },
    reactVueIndex: {
      type: Number,
      default: 0,
    },
    // 预估行高度
    estimatedItemSize: {
      type: Number,
      default: () => { return 50; },
    },

    // 统计区数据
    summaryBody: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {

    };
  },
  inject: ["CONSTNAME"],
  computed: {
    getHeight() {
      let ganttBgCss = "";
      if (this.rowsShow.length <= 0) {
        ganttBgCss = "";
      } else {
        ganttBgCss = {
          "height": this.rowsShow.length * this.estimatedItemSize + "px",
        };
      }
      return ganttBgCss;
    },
    showArr() {
      // this.cols.forEach(element => {
      //   element.unshift("-");
      //   element.unshift("-");
      // });
      return this.cols;
    },
  },
  methods: {
    scrollEvent(el) {
      const _self = this;
      if (_self.$store.state.showMode == "both") {
        const scrollTop = _self.$el.scrollTop;
        const _reactVueComponent = this.reactVueComponent;
        let targetEl;
        if (
          _reactVueComponent != null &&
            _reactVueComponent.$el != null
        ) {
          targetEl = _reactVueComponent.$el;
          targetEl.scrollTop = scrollTop;
        } else {
          // console.log("无绑定联动组件值·C");
          const targetEl = _self.$el.parentNode.parentNode.parentNode.parentNode.getElementsByClassName(
            "summary-normal",
          )[_self.reactVueIndex];
          targetEl.scrollTop = scrollTop;
        }

      }
    },

  },
};

</script>
<style scoped lang='less'>
.content-form{
  // width: 100%;
  height: 100%;
  &.drag-act{
    z-index: 10;
  }
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
  .gantt-row {
    position: relative;
    display: block;
    overflow: hidden;
    border-color: @cBorder;
    border-color: var(--border-color, @cBorder);
    border-width: 1px;
    border-bottom-style: solid;
    // &.act {
    //   background-color: @bgActRow;
    // }
    &.disable {
      background-color: rgba(225,225,225,0.2);
    }
    &.task-info-row-isSelect{
      background: @cWBSRowBg;
    }
    &.borderB {
      border-bottom: 1px solid @cBorder;
      border-bottom: 1px solid var(--border-color, @cBorder);
    }
  }
  .cell-col {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    box-sizing: border-box;
    width: @cellWidth;
    overflow: hidden;
    text-align: center;
    height: 100%;
    // 边线
    border-color: @cBorder;
    border-color: var(--border-color, @cBorder);
    border-width: 1px;
    border-left-style: solid;
    &:first-of-type{
      border-left: 0;
    }
    &:last-of-type{
      border-right: 1px solid @cBorder;
      border-right: 1px solid var(--border-color, @cBorder);
      z-index: 20;
    }
  }

  .empty-box{
    .row {
      display: flex;
      box-sizing: border-box;
      height: @summaryCellHeight;
      border-bottom: 1px solid @cBorderX;
      border-bottom: 1px solid var(--borderX-color, @cBorderX);
      &:last-of-type{
        border-bottom: none;
      }
    }
    .summary-data {
      .text-oneline;
      width: @cellWidth;
      border-left: 1px solid @cBorder;
      border-left: 1px solid var(--border-color, @cBorder);
      text-align: center;
      box-sizing: border-box;
      line-height: @summaryCellHeight;
      height: @summaryCellHeight;
      &.isNegative{
        color: @cRed;
      }
      /* &:first-of-type{
        border-left: 1px solid @cBorder;
        border-left: 1px solid var(--border-color, @cBorder);
      } */
    }
    .no-border-left {
      border-left: 0;
    }
    .no-flex-shrink{
      flex-shrink: 0;
    }
  }

}
</style>
